import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import RouteKey from './key';
import AccessArrangementRequestPage from '../pages/accessArrangement/AccessArrangementRequest';
import ImportantNotes from '../pages/accessArrangement/ImportantNotes';
import SelectConditionPage from '../pages/accessArrangement/SelectCondition';
import AccessArrangementsPage from '../pages/accessArrangement/AccessArrangementsPage';
import ReviewApplicationPage from '../pages/accessArrangement/ReviewApplication';
import SubmittedPage from '../pages/accessArrangement/SubmittedPage';
import SummaryPage from '../pages/accessArrangement/Summary';
import { Role } from '../models';
import SelectCandidate from '../pages/accessArrangement/coordinator/SelectCandidate';
import ImportantNotesCoordinator from '../pages/accessArrangement/coordinator/ImportantNotesCoordinator';
import SelectConditionCoordinator from '../pages/accessArrangement/coordinator/SelectConditionCoordinator';
import AccessArrangementsListing from '../pages/accessArrangement/coordinator/AccessArrangementsListing';
import AccessArrangementRequestCoordinator from '../pages/accessArrangement/coordinator/AccessArrangementRequestCoordinator';
import ReviewApplicationCoordinator from '../pages/accessArrangement/coordinator/ReviewApplicationCoordinator';
import IndividualReportCoordinator from '../pages/accessArrangement/coordinator/IndividualReportCoordinator';
import IndividualReportPage from '../pages/accessArrangement/IndividualReport';
import PrivateRoute from '../modules/profile/components/PrivateRoute';

const { error: errorRoute } = RouteKey.child;
const {
  selectCondition,
  individualReport,
  importantNotes,
  accessArrangementsRequest,
  ammendAccessArrangements,
  reviewApplication,
  root,
  ammendSelectCondition,
  submitted,
  summary,
  coordinatorRoot,
  coordinatorImportantNotes,
  coordinatorSelectCandidate,
  coordinatorSelectCondition,
  coordinatorAccessArrangementsRequest,
  coordinatorIndividualReport,
  coordinatorReviewApplication,
  coordinatorSubmitted,
  coordinatorSummary,
  coordinatorAmendSelectCondition,
  coordinatorAmendAccessArrangements,
} = RouteKey['access-arrangement'].child;

export const AppealRoute = () => {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

  const accessArrangementTitle = t(
    'accessArrangement->>AccessArrangementRoute.ApplyforAccessArrangements'
  );

  const routeSteps = [
    { label: t('accessArrangement->>Steps.StepOne') },
    { label: t('accessArrangement->>Steps.StepTwo') },
    { label: t('accessArrangement->>Steps.StepThree') },
    { label: t('accessArrangement->>Steps.StepFour') },
  ];

  const routeStepsCoordinator = [
    { label: t('accessArrangement->>StepsCoordinator.SelectCandidate') },
    { label: t('accessArrangement->>StepsCoordinator.ConditionReason') },
    { label: t('accessArrangement->>StepsCoordinator.AccessArrangementsRequest') },
    { label: t('accessArrangement->>StepsCoordinator.IndividualReport') },
    { label: t('accessArrangement->>StepsCoordinator.ReviewApplication') },
  ];

  return (
    <Switch>
      <PrivateRoute exact path={`${path}/${coordinatorRoot.route}`} roles={[Role.coordinator]}>
        <AccessArrangementsListing />
      </PrivateRoute>

      <PrivateRoute
        exact
        path={`${path}/${coordinatorRoot.route}/${coordinatorImportantNotes.route}`}
        roles={[Role.coordinator]}
      >
        <ImportantNotesCoordinator />
      </PrivateRoute>

      <PrivateRoute
        exact
        path={`${path}/${coordinatorRoot.route}/${coordinatorSelectCandidate.route}`}
        roles={[Role.coordinator]}
      >
        <SelectCandidate routeSteps={routeStepsCoordinator} />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/${coordinatorRoot.route}/${coordinatorSelectCondition.route}/:uuid`}
        roles={[Role.coordinator]}
      >
        <SelectConditionCoordinator
          title={accessArrangementTitle}
          routeSteps={routeStepsCoordinator}
          activeStep={1}
        />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/${coordinatorRoot.route}/${coordinatorAmendSelectCondition.route}/:uuid`}
        roles={[Role.coordinator]}
      >
        <SelectConditionCoordinator
          title={accessArrangementTitle}
          routeSteps={routeStepsCoordinator}
          activeStep={1}
          amendment
        />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/${coordinatorRoot.route}/${coordinatorAccessArrangementsRequest.route}/:uuid`}
        roles={[Role.coordinator]}
      >
        <AccessArrangementRequestCoordinator routeSteps={routeStepsCoordinator} activeStep={2} />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/${coordinatorRoot.route}/${coordinatorAmendAccessArrangements.route}/:uuid`}
        roles={[Role.coordinator]}
      >
        <AccessArrangementRequestCoordinator
          routeSteps={routeStepsCoordinator}
          activeStep={2}
          amendment
        />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/${coordinatorRoot.route}/${coordinatorIndividualReport.route}/:uuid`}
        roles={[Role.coordinator]}
      >
        <IndividualReportCoordinator
          title={accessArrangementTitle}
          routeSteps={routeStepsCoordinator}
          activeStep={3}
        />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/${coordinatorRoot.route}/${coordinatorReviewApplication.route}/:uuid/:mode`}
        roles={[Role.coordinator]}
      >
        <ReviewApplicationCoordinator
          title={accessArrangementTitle}
          routeSteps={routeStepsCoordinator}
          activeStep={4}
        />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/${coordinatorRoot.route}/${coordinatorSubmitted.route}/:uuid`}
        roles={[Role.coordinator]}
      >
        <SubmittedPage />
      </PrivateRoute>
      <PrivateRoute
        exact
        path={`${path}/${coordinatorRoot.route}/${coordinatorSummary.route}/:uuid`}
        roles={[Role.coordinator]}
      >
        <SummaryPage isGroup />
      </PrivateRoute>
      <Route exact path={`${path}/${root.route}`}>
        <AccessArrangementsPage />
      </Route>
      <Route exact path={`${path}/${root.route}/${importantNotes.route}`}>
        <ImportantNotes />
      </Route>
      <Route exact path={`${path}/${root.route}/${selectCondition.route}/:uuid`}>
        <SelectConditionPage
          title={accessArrangementTitle}
          routeSteps={routeSteps}
          activeStep={0}
        />
      </Route>
      <Route exact path={`${path}/${root.route}/${accessArrangementsRequest.route}/:uuid`}>
        <AccessArrangementRequestPage routeSteps={routeSteps} activeStep={1} />
      </Route>
      <Route exact path={`${path}/${root.route}/${ammendAccessArrangements.route}/:uuid`}>
        <AccessArrangementRequestPage routeSteps={routeSteps} activeStep={1} amendment />
      </Route>
      <Route exact path={`${path}/${root.route}/${individualReport.route}/:uuid`}>
        <IndividualReportPage routeSteps={routeSteps} activeStep={2} />
      </Route>
      <Route exact path={`${path}/${root.route}/${reviewApplication.route}/:uuid/:mode`}>
        <ReviewApplicationPage
          title={accessArrangementTitle}
          activeStep={3}
          routeSteps={routeSteps}
        />
      </Route>
      <Route exact path={`${path}/${root.route}/${submitted.route}/:uuid`}>
        <SubmittedPage />
      </Route>
      <Route exact path={`${path}/${root.route}/${ammendSelectCondition.route}/:uuid`}>
        <SelectConditionPage
          title={accessArrangementTitle}
          routeSteps={routeSteps}
          activeStep={0}
          amendment
        />
      </Route>
      <Route exact path={`${path}/${root.route}/${summary.route}/:uuid`}>
        <SummaryPage isGroup={false} />
      </Route>
      <Route path="*" exact>
        <Redirect to={`/${errorRoute}`} />
      </Route>
    </Switch>
  );
};

export default AppealRoute;
